(() => {
  const toTopBtn = document.querySelector("[data-to-top]");
  const prefersReducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;

  // ページ上部へ
  if (toTopBtn) {
    const onScroll = () => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      toTopBtn.classList.toggle("is-visible", y > 400);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    toTopBtn.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: prefersReducedMotion ? "auto" : "smooth" });
    });
  }

  // ページ内リンクのスクロール（Safari等の挙動差を吸収）
  document.addEventListener("click", (e) => {
    const a = e.target instanceof Element ? e.target.closest('a[href^="#"]') : null;
    if (!a) return;

    const href = a.getAttribute("href");
    if (!href || href === "#") return;

    const id = href.slice(1);
    const target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();
    target.scrollIntoView({ behavior: prefersReducedMotion ? "auto" : "smooth", block: "start" });
  });
})();

